import { IDetailsViewInfo } from '../../interfaces';
import { IDetailsViewService } from './details-view.interface';
import { injectable } from 'inversify';
import { NEVER, Observable } from 'rxjs';

@injectable()
export class DetailsViewMock implements IDetailsViewService {
    updateOrderList(): void {
        throw new Error('Method not implemented.');
    }
    asObservable(): Observable<IDetailsViewInfo> {
        return NEVER;
    }
}
